/*
 * HONEYWELL INC.,
 * COPYRIGHT (c) 2022
 * ALL RIGHTS RESERVED
 *
 * This software is a copyrighted work and/or information protected as a trade secret.
 * Legal rights of Honeywell Inc. in this software is distinct from ownership of any medium
 * in which the software is embodied. Copyright or trade secret notices included must be
 * reproduced in any copies authorized by Honeywell Inc.
 *
 */

import { Badge } from '@scuf/common';
import React, { useContext } from 'react';
import { ApiContext } from '../../../../context/ApiContext';
import { ECartAt } from '../../../DashboardKPIWidgets/IEnergyManagementProps';
import TruncateText from '../../../shared/TruncatedText/TruncateText';
interface IUtilitySiteMeterProps {
  savings: number;
  name: string;
  id: string;
}
const UtilitySiteMeterColumnComponent = (props: IUtilitySiteMeterProps) => {
  const { savings, name, id } = props;
  const MAX_ROW_LIMIT = 5;
  const apiContext = useContext(ApiContext);
  const { onPortfolioSiteClick, apiCallAt } = apiContext;
  const onSiteclick = (siteId: string) => {
    if (id) {
      if (onPortfolioSiteClick) {
        onPortfolioSiteClick(siteId);
      }
    }
  };
  const clsName =
    apiCallAt === ECartAt.siteLabel
      ? 'score-category-meterdata-meter'
      : 'score-category-meterdata-meter portfolio-navigation-link';
  return (
    <span
      className={clsName}
      onClick={() => {
        onSiteclick(id);
      }}
    >
      {savings < 0 ? (
        <Badge color="red" empty={true} />
      ) : (
        <span className="dummyBadge" />
      )}
      <span className="score-category-percent">
        {name && name.length <= MAX_ROW_LIMIT ? (
          <div className="measurementunit">
            <TruncateText text={name} />
          </div>
        ) : (
          <div>{name}</div>
        )}
      </span>
    </span>
  );
};

export default UtilitySiteMeterColumnComponent;
